import React from "react";
import { Grid, Box, Stack, Typography, Container } from "@mui/material";
import "./Header.css";
import Button from "@mui/material/Button";
import blob from "../../../assets/animation/blobanimation.svg";
import { Link } from "react-scroll";
import resume from "../../../assets/pdf/tharindu_cv.pdf";

export default function HeroSection() {
  return (
    <Container>
      <Grid
        container
        spacing={4}
        // sx={{ marginTop: { xs: "10px", md: "px" } }}
        alignItems="center"
        justifyContent="center"
        zIndex="0"
        sx={{
          marginTop: { xs: "", md: "0px" },
          // backgroundColor: 'red'
        }}
      >
        <Grid
          container
          width="100%"
          sx={{ marginTop: "200px", justifyContent: "center" }}
        >
          <Grid
            item
            xs={12}
            md={7}
            sx={
              {
                // padding: "20px",
                //   marginTop:{xs}
              }
            }
          >
            <Box padding="10px" margin="40px">
              <Stack color="">
                <Typography
                  variant="h7"
                  sx={{
                    color: "white",
                    fontWeight: 500,
                    fontFamily: "Getboreg Trial Only",
                    fontSize: { xs: "15px", md: "18px" },
                    letterSpacing: "2px",
                  }}
                >
                  Hi <span className="shake2">👋</span>! I'm
                </Typography>
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 700,
                    fontFamily: "g Game TC",
                    fontSize: { md: "50px", xs: "25px" },
                    letterSpacing: { md: "6px", xs: "2px" },
                  }}
                  marginTop="15px"
                  className="rotate move"
                >
                  <span style={{ color: "#00adb5" }}>T</span>
                  <span style={{ color: "#00adb5" }}>H</span>
                  <span style={{ color: "#00adb5" }}>A</span>
                  <span style={{ color: "#00adb5" }}>R</span>
                  <span style={{ color: "#00adb5" }}>N</span>
                  <span style={{ color: "#00adb5" }}>D</span>
                  <span style={{ color: "#00adb5" }}>U</span>

                  <br></br>
                  <span style={{ color: "#00adb5" }}>M</span>
                  <span style={{ color: "#00adb5" }}>A</span>
                  <span style={{ color: "#00adb5" }}>D</span>
                  <span style={{ color: "#00adb5" }}>H</span>
                  <span style={{ color: "#00adb5" }}>U</span>
                  <span style={{ color: "#00adb5" }}>S</span>
                  <span style={{ color: "#00adb5" }}>H</span>
                  <span style={{ color: "#00adb5" }}>A</span>
                  <span style={{ color: "#00adb5" }}>N</span>
                </Typography>
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: 500,
                    fontFamily: "Getboreg Trial Only",
                    color: "white",
                    letterSpacing: { md: "5px", xs: "3px" },
                    fontSize: { xs: "15px", md: "18px" },
                    marginTop: { xs: "8px" },
                  }}
                >
                  {/* <span className="shine"> */}
                  Software engineers In Sri Lanka
                  {/* </span> */}
                </Typography>
                <a link  href="#projects">
                  <Button
                    variant="contained"
                    sx={{
                      marginTop: "15px",
                      bgcolor: "#00adb5",
                      width: "100%",
                      fontSize: "12px",
                      cursor: "pointer",
                      maxWidth: "180px",
                      fontWeight: "600",
                      "&:hover": {
                        backgroundColor: "skyblue",
                        color: "white",
                        cursor:"pointer"
                      },
                    }}
                  >
                    <span>Watch My Works</span>
                  </Button>
                </a>
              </Stack>
              <Grid
                item
                sx={{ display: { xs: "none", md: "block", marginTop: "30px" } }}
              >
                <Stack direction="row" spacing={2}>
                  <Link
                    to="skills"
                    spy={true}
                    smooth={true}
                    // offset={-70}
                    duration={250}
                    style={{
                      textDecoration: "none",
                      color: "white",
                      cursor: "pointer",
                    }}
                  >
                    <span
                      style={{
                        color: "white",
                        fontFamily: "Getboreg Trial Only",
                        letterSpacing: "2px",
                      }}
                    >
                      Scroll Down
                    </span>
                  </Link>

                  <div className="scrolldown" style={{ color: "skyblue" }}>
                    <div className="chevrons">
                      <div className="chevrondown"></div>
                      <div className="chevrondown"></div>
                    </div>
                  </div>
                </Stack>
              </Grid>
            </Box>
          </Grid>
          <Grid
            item
            md={5}
            style={{
              width: { xs: { display: "none" } },
            }}
          >
            <img src={blob} alt="" />
          </Grid>
        </Grid>
      </Grid>
    </Container>
  );
}
